<template>
  <div class="BSCTooltip" @click="clickTooltip">
    <div
      class="BSCTooltip-slot"
      :class="[
        `is-${position}`,
        { 'is-show': show },
        { 'is-clickable': isClickable },
        `is-${type}`
      ]"
    >
      <slot name="content" />
    </div>
    <div v-if="show" @click.stop="show = false" class="BSCTooltip-bk" />
    <slot />
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCTooltip',
  props: {
    position: {
      type: String,
      default: 'left',
      validator: value => {
        return (
          ['top', 'bottom', 'left', 'left-inv', 'right'].indexOf(value) !== -1
        )
      }
    },
    isClickable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    clickTooltip() {
      if (this.isClickable) this.show = !this.show
    }
  }
}
</script>
